$(document).ready(function () {
  let deskBurger = document.getElementsByClassName('component_header_burger-desktop');
  let deskMenu = document.getElementsByClassName('desktop-navigations');
  deskBurger[0].addEventListener('click', () => {
    console.log('hello clicked');
    if(deskMenu[0].classList.contains('desktop-navigations-active')) {
      deskMenu[0].classList.remove('desktop-navigations-active');
    } else {
      deskMenu[0].classList.add('desktop-navigations-active');
    }
  });
  console.log(deskBurger);
  setTimeout( () => {
    if( document.getElementById('recover-password-a') ) {
      document.getElementById('recover-password-a').addEventListener('click', () => {
        document.getElementById('recover-password').style.display = 'block';
        document.getElementById('account-login').style.display = 'none';
      });
      document.getElementById('account-login-a').addEventListener('click', () => {
        document.getElementById('account-login').style.display = 'block';
        document.getElementById('recover-password').style.display = 'none';
      });
    }
    function getNewTotal( total ) {
      const formattedPrice = new Intl.NumberFormat('en-US', {
        style: 'currency',
        // currency: window.currencyCode // uncomment if ever it needs to be dynamic for now static USD
        currency: 'USD'
      }).format(total / 100);
      return formattedPrice;
    }
    if( document.getElementById('quantityMinus') ) {
      document.getElementById('quantityMinus').addEventListener('click', () => {
        var qCurrent = parseInt(document.getElementById('quantityBox').value, 10);
        if( qCurrent > 1 ) {
          document.getElementById('quantityBox').value = qCurrent - 1;
          let tempTotal = Number(document.getElementById('currentPrice').value) * Number(document.getElementById('quantityBox').value);
          document.getElementById('totalPrice').innerText = getNewTotal(tempTotal);
        }
      });
      document.getElementById('quantityPlus').addEventListener('click', () => {
        var qCurrent = document.getElementById('quantityBox').value;
        document.getElementById('quantityBox').value = Number(qCurrent) + 1;
        let tempTotal = Number(document.getElementById('currentPrice').value) * Number(document.getElementById('quantityBox').value);
        document.getElementById('totalPrice').innerText = getNewTotal(tempTotal);
      });
    }
    let currentVariantId = new URLSearchParams(window.location.search).get('variant');

    function checkVariantChange() {
      const newVariantId = new URLSearchParams(window.location.search).get('variant');
      if (newVariantId !== currentVariantId) {
        setTimeout( () => {
          document.getElementById('totalPrice').innerText = getNewTotal(document.getElementById('currentPrice').value);
        }, 500);
      }
    }

    window.addEventListener('popstate', checkVariantChange);
    window.addEventListener('pushState', checkVariantChange);
    window.addEventListener('replaceState', checkVariantChange);
    window.addEventListener('hashchange', checkVariantChange);

    ['pushState', 'replaceState'].forEach(fn => {
      const original = history[fn];
      history[fn] = function () {
        const result = original.apply(this, arguments);
        checkVariantChange();
        return result;
      };
    });

    // setInterval(checkVariantChange, 500);
  }, 1000);  
  const showMoreButton = document.getElementById('show-more-button');
  
  if (showMoreButton) {
    showMoreButton.addEventListener('click', function() {
      const hiddenArticles = document.querySelectorAll('.component_news_card.is-hidden');

      hiddenArticles.forEach(function(article) {
        article.classList.remove('is-hidden');
      });
      showMoreButton.style.display = 'none';
    });
  }

 const addButtons = document.querySelectorAll(".component_product_card_add_button");
const cursorWrap = document.querySelector(".component_cursor_wrap");

if (addButtons.length > 0 && cursorWrap) {
  addButtons.forEach((addButton) => {
    addButton.addEventListener("mouseenter", () => {
      cursorWrap.style.display = "none";
    });

    addButton.addEventListener("mouseleave", () => {
      cursorWrap.style.display = "";
    });
  });
}

});
  const runOnDomReady = (callback) => {
    return document.addEventListener("DOMContentLoaded", callback);
  };
   const initSlider = (identifier, config, breakpoint) => {
    let slider = null;
    if (breakpoint) {
      const runOnMatch = (media) => {
        if (media.matches && !slider) {
          slider = new Swiper(identifier, config);
          slider.init();
        }
        if (!media.matches && slider) {
          slider.destroy();
          slider = null;
        }
      };
      const media = window.matchMedia(
        `only screen and (${breakpoint >= 0 ? "min" : "max"}-width: ${
          breakpoint >= 0 ? breakpoint : breakpoint * -1
        }px)`
      );
      runOnMatch(media);
      window.addEventListener("resize", () => {
        runOnMatch(media);
      });
      media.addEventListener("change", runOnMatch);
    } else {
      slider = new Swiper(identifier, config);
    }
  };
  const initSliderTransformRemover = (swiper) => {
    const { el, slides } = swiper;
    if (!el.classList.contains("init-slider-transform-remover")) {
      el.classList.add("init-slider-transform-remover");
      slides.forEach((slide) => {
        const transformedElements = slide.querySelectorAll(
          "[data-slider='transform-element']"
        );
        const setters = slide.querySelectorAll(
          "[data-slider='transform-setter']"
        );
        if (setters.length > 0) {
          setters.forEach((setter) => {
            setter.addEventListener("click", () => {
              slide.classList.add("transform-none");
              swiper.wrapperEl.classList.add("transform-none");
              el.closest(".swiper-container").style.zIndex = 9999;
              if (transformedElements.length > 0) {
                transformedElements.forEach((element) => {
                  element.classList.add("transform-none");
                });
              }
            });
          });
        }
        const resetters = slide.querySelectorAll(
          "[data-slider='transform-resetter']"
        );
        if (resetters.length > 0) {
          resetters.forEach((resetter) => {
            resetter.addEventListener("click", () => {
              slide.classList.remove("transform-none");
              swiper.wrapperEl.classList.remove("transform-none");
              el.closest(".swiper-container").removeAttribute("style");
              if (transformedElements.length > 0) {
                transformedElements.forEach((element) => {
                  element.classList.remove("transform-none");
                });
              }
            });
          });
        }
      });
    }
  };
  const resolveSliderHeight = (swiper) => {
    const params = swiper.params;
    const swiperEl = swiper.el;
    if (params.direction && params.direction === "vertical") {
      const swiperSlides = swiper.slides;
      const slidesPerView = params.slidesPerView || 1;
      const activeIndex = swiper[params.loop ? "realIndex" : "activeIndex"];
      let height = 0;
      let index = activeIndex + (slidesPerView - 1);
      while (index >= activeIndex) {
        if (index < swiperSlides.length) {
          height += swiperSlides[index].firstChild.offsetHeight;
        }
        index--;
      }
      const spaceBetween = params.spaceBetween;
      if (spaceBetween && slidesPerView && (slidesPerView > 1)) {
        height += (spaceBetween * slidesPerView);
      }
      swiperEl.style.height = height > 0 ? `${height}px` : "auto";
    } else {
      swiperEl.style.height = "auto";
    }
  };
  const removeSliderTransform = (swiper, targetIdentifier) => {
    swiper.slides.forEach((slide) => {
      const targetElement = targetIdentifier
        ? slide.querySelector(targetIdentifier)
        : slide;
      if (!targetElement.classList.contains("init-transform-remover")) {
        targetElement.classList.add("init-transform-remover");
        targetElement.addEventListener("click", () => {
          slide.classList.toggle("transform-none");
          swiper.wrapperEl.classList.toggle("transform-none");
        });
      }
    });
  };
  /*Typewriter*/
function typeTextOnView(id, speed = 35) {
  const element = document.getElementById(id);
  if (!element) return;
  let hasAnimated = false;
  // Utility: wrap text node characters in span
  function wrapCharactersInSpans(node) { 
    const fragment = document.createDocumentFragment();
    node.textContent.split('').forEach(char => {
      const span = document.createElement('span');
      span.textContent = char;
      span.style.opacity = '0.6';
      span.style.transition = 'opacity 0.3s ease';
      fragment.appendChild(span);
    });
    return fragment;
  }
  // Recursive function to walk the DOM and wrap only text nodes
  function processNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const spanWrapped = wrapCharactersInSpans(node);
      node.replaceWith(spanWrapped);
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      node.childNodes.forEach(child => processNode(child));
    }
  }
  // Preserve layout height
  const clone = element.cloneNode(true);
  clone.style.position = 'absolute';
  clone.style.visibility = 'hidden';
  clone.style.pointerEvents = 'none';
  clone.style.height = 'auto';
  clone.style.opacity = 1;
  element.parentNode.insertBefore(clone, element.nextSibling);
  const fixedHeight = clone.offsetHeight + 'px';
  clone.remove();
  element.style.height = fixedHeight;
  element.style.overflow = 'hidden';
  // Typewriter animation (opacity fade)
  function typeWriter() {
    const spans = element.querySelectorAll('span');
    let i = 0;
    function fadeChar() {
      if (i < spans.length) {
        spans[i].style.opacity = '1';
        i++;
        setTimeout(fadeChar, speed);
      }
    }
    fadeChar();
  }
  // Observe when element enters viewport
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasAnimated) {
          hasAnimated = true;
          typeWriter();
          observer.unobserve(element);
        }
      });
    },
    { threshold: 0.5 }
  );
  observer.observe(element);
  // Run character wrapping after DOM is loaded
  processNode(element);
}
  // Initialize when DOM is ready
  document.addEventListener("DOMContentLoaded", () => {
    typeTextOnView('typewriter-text');
  });
  runOnDomReady(() => {
    initSlider("#testimonial-slider", {
      slidesPerView: "auto",
      spaceBetween: 40,
      navigation: {
        nextEl: '#testimonial-next',
        prevEl: '#testimonial-prev',
      },
    });
  });


  //Product slider
  runOnDomReady(() => {
     initSlider("#product-slider", {
    			slidesPerView: "auto",
    			spaceBetween: 24,
         breakpoints: {
   				 0: {
        		slidesPerView: 1
  				  },
             576: {
        		slidesPerView: 1.4
  				  },
            768: {
        		slidesPerView: "2"
  				  },
             989: {
        		slidesPerView: "auto"
  				  }
          }
  		});
  });

    //Featured Blogs
    runOnDomReady(() => {
     initSlider("#news-slider", {
    			slidesPerView: "auto",
    			spaceBetween: 12
  		});
  });

//Product Video Slider
  runOnDomReady(() => {
     initSlider("#video-slider-1", {
    			slidesPerView: 3,
    			spaceBetween: 24,
          on:{
          	init: initSliderTransformRemover
          },
          breakpoints: {
           0: {
           		slidesPerView: 1
           },
       		 576: {
           		slidesPerView: 2
           },
       		 992: {
           		slidesPerView: 3
           }
          }
  		});
      initSlider("#video-slider-2", {
    			slidesPerView: 3,
    			spaceBetween: 24,
          on:{
          	init: initSliderTransformRemover
          },
          breakpoints: {
           0: {
           		slidesPerView: 1
           },
       		 576: {
           		slidesPerView: 2
           },
       		 992: {
           		slidesPerView: 3
           }
          }
  		});
      initSlider("#video-slider-3", {
    			slidesPerView: 3,
    			spaceBetween: 24,
          on:{
          	init: initSliderTransformRemover
          },
          breakpoints: {
           0: {
           		slidesPerView: 1
           },
       		 576: {
           		slidesPerView: 2
           },
       		 992: {
           		slidesPerView: 3
           }
          }
  		});
  });
